import WOW from 'wowjs';

new WOW.WOW(
    {
      animateClass: 'animated',
      offset: 50
    }
);